import React from 'react';
import { Helmet } from 'react-helmet-async';

function TermsAndConditions() {
    return (
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-lg max-w-4xl mx-auto my-10">
            <Helmet>
                <title>Terms and Conditions | Health Portal</title>
            </Helmet>
            <h1 className="text-3xl font-bold text-brand-secondary mb-6">Terms and Conditions</h1>
            <p className="mb-4 text-gray-600">Last updated: March 2025</p>

            <div className="space-y-6 text-gray-700">
                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">1. Introduction</h2>
                    <p>Welcome to the Health Portal, operated by Smart City Ajmer (operating as Search is End!). These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to be bound by these terms.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">2. Use of Service</h2>
                    <p>The Health Portal is designed to store and display emergency medical information. You are solely responsible for ensuring that the medical information you provide is accurate and up to date.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">3. Subscription and Payments</h2>
                    <p>Access to certain features of the Health Portal requires a paid subscription. Payments are processed securely via Razorpay. By subscribing, you authorize us to charge the applicable fees to your chosen payment method.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">4. User Responsibilities</h2>
                    <p>You agree not to misuse the platform, attempt to gain unauthorized access, or use the service for any illegal purposes. You must keep your login credentials secure.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">5. Limitation of Liability</h2>
                    <p>Smart City Ajmer (operating as Search is End!) and the Health Portal team are not medical professionals. The information stored on this platform is for informational purposes in emergencies. We shall not be held liable for any inaccuracies in the data provided by users or any consequences arising from its use.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">6. Governing Law & Jurisdiction</h2>
                    <p>Any disputes, claims, or court cases arising out of or relating to these Terms and Conditions or the use of our services shall be subject exclusively to the jurisdiction of the courts located in Ajmer, being the company's main head office city.</p>
                </section>
            </div>
        </div>
    );
}

export default TermsAndConditions;
